/**
 * Ein Interface welches als Wrapper für abbildbare Items fungiert
 */
export abstract class DisplayItem {
  constructor(private readonly _id: string | undefined) {}

  abstract get type(): DisplayItemType;

  get id(): string | undefined {
    return this._id;
  }
}

/**
 * Verschiedene Displayitemtypen
 */
export enum DisplayItemType {
  INFO,
  MESSAGE,
  FILEMESSAGE
}
